import { GET_SALES_REPORT, GET_SALES_REPORT_BY_ID, SORT_SALES_REPORT, EXPORT_SALES_REPORT } from '../actions/types';
import _ from 'lodash';

const INITIAL_STATE = {
    list: [],
    summary: null,
    startDate: null,
    endDate: null,
    selectedSalesReport: {
        order_date: [],
        order_details: {
            total_amount: ''
        }
    },
    sortColumn: 'order_date',
    sortDirection: 'ascending',
    SalesReportModalOpen: false,
    exportModal: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_SALES_REPORT:
            return {
                ...state,
                startDate: action.payload.start_date,
                endDate: action.payload.end_date,
                list: action.payload.docs,
                summary: action.payload.sum,
                SalesReportModalOpen: false
            }

        case GET_SALES_REPORT_BY_ID:
            let salesreport = state.list.find((salesreport) => salesreport._id === action.payload);
            return {
                ...state,
                selectedSalesReport: salesreport,
                SalesReportModalOpen: true
            }

        case SORT_SALES_REPORT:
            let sorted = null;
            let sort_column = action.payload;
            let direction = 'ascending';
            if (state.sortColumn !== sort_column) {
                console.log('Sorting by ' + sort_column);
                sorted = _.sortBy(state.list, [sort_column]);
            } else {
                sorted = state.list.reverse();
                console.log(sorted);
                direction = (state.sortDirection === 'ascending') ? 'descending' : 'ascending';
                console.log('Sorting in ' + direction);
            }

            return {
                ...state,
                list: sorted,
                sortColumn: sort_column,
                sortDirection: direction
            }

        case EXPORT_SALES_REPORT:
            return {
                ...state,
                exportModal: action.payload
            }


        default:
            return state;
    }
}